<template>
	<div class="home_wrapper">
		<div class="home_container">
			<AllGamesBannerMobile msg="AllGamesView" />
		</div>

		<div class="all_games_container">
			<div class="all_games_gradient_1">
				<div class="menu_top">
					<div class="menu_scroll_container">
						<div 
							class="menu_top_item_wrapper" 
							v-for="(item, index) in openMenu" :key="'open_menu_' + index" 
							:class="{ active: index === currentOpenMenuIndex }">
							<div 
								class="menu_top_item" 
								@click="showGameFromTypeBottom(index)">
								<div><img :src="item.icon" alt=""></div>
								<div>{{ item.tit }}</div>
							</div>
						</div>
					</div>
				</div>

				<div class="menu_bottom">
					<div 
						class="menu_bottom_item animate__animated animate__fadeInLeft" 
						v-for="(item, index) in allGames" :key="currentOpenMenuIndex + '-' + index + '-' + item.game_id" 
						v-if="item.visible" 
						@click="gotoGameDetail(item.game_id)">
						<img v-lazy="item.icon" alt="" />
						<div v-if="false">{{ item.game_name }}</div>
					</div>
					<div class="menu_bottom_item"></div>

					<div 
						v-if="false"
						class="menu_cross_line" 
						v-for="(itemLine, i) in crossLines" :key="'cross_line_' + i" 
						:class="'menu_cross_line_box_' + i">
					</div>
				</div>
			</div>
		</div>

		<BusinessCooperationMobile />

		<FooterMenuMobile />
	</div>
</template>

<script>
/**
 * Mobile AllGamesView
 * @ is an alias to /src
 */
import AllGamesBannerMobile      from '@/components/mobile/AllGamesBanner.vue';
import BusinessCooperationMobile from '@/components/mobile/BusinessCooperation.vue';
import FooterMenuMobile          from '@/components/mobile/FooterMenu.vue';
import { fetchAllGamesCached }   from '@/api/gameDataLoader';
import {
	NAV_IS_PAGE_SCROLL,
	CURRENT_GAME_ID
} from '@/type/mutation';

export default {
	name      : 'AllGamesViewMobile',
	components: {
		AllGamesBannerMobile,
		BusinessCooperationMobile,
		FooterMenuMobile
	},

	data() {
		return {
			// 父级容器背景图
			// homeContainerBackgroundImage: require('../../assets/static/imgs/home/banner-bg.png'),
			// homeContainerBackgroundImage: require('../../assets/static/imgs/home/index-bg-b1.png'),
			crossImage            : require('../../assets/static/imgs/common/m/cross.png'),
			currentOpenMenuIndex  : 0,
			currentOpenMenuContent: [],
			openMenu: [
				{
					icon: require('../../assets/static/imgs/common/m/icon_all.png'),
					tit : 'All Games'
				},
				{
					icon: require('../../assets/static/imgs/common/m/icon_Global.png'),
					tit : this.$t('index.sub_nav.tit_1')
				},
				{
					icon: require('../../assets/static/imgs/common/m/icon_MiddleEast.png'),
					tit : this.$t('index.sub_nav.tit_2')
				},
				{
					icon: require('../../assets/static/imgs/common/m/icon_America.png'),
					tit : this.$t('index.sub_nav.tit_3')
				},
				{
					icon: require('../../assets/static/imgs/common/m/icon_SoutheastAsia.png'),
					tit : this.$t('index.sub_nav.tit_4')
				}
			],
			allGames      : [],
			allGamesSource: []
		};
	},

	mounted() {
		// console.log('=== Mobile AllGamesView mounted <<<');

		window.scrollTo(0, 0);

		// 动态添加背景图
		// this.addBackgroundImage();

		// 监听页面滚动
    	window.addEventListener('scroll', this.handleScroll);

		// 默认加载：本地缓存优先，无则请求
		this.loadAllGames();
	},

	methods: {
		// 动态添加背景图
		addBackgroundImage()
		{
			const container                = document.querySelector('.home_container');
			// container.style.background  = `rgba(162, 112, 234, .2) url(${this.homeContainerBackgroundImage}) center bottom no-repeat`;
			container.style.background     = `url(${this.homeContainerBackgroundImage}) top center no-repeat`;
			container.style.backgroundSize = `cover`;
		},

		// 监听页面滚动
		handleScroll()
		{
			let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
	        if(scrollTop)// 如果滚动距离大于0，则显示导航栏背景色
			{
				this.$store.commit(NAV_IS_PAGE_SCROLL, true);
	      	}
			else if(scrollTop === 0)// 如果滚动距离等于0，则显示导航栏背景色
			{
				this.$store.commit(NAV_IS_PAGE_SCROLL, false);
	      	}
		},

		// 二级页面点击导航，打开DEMO弹窗
		openDemoDialog(value)
		{
			this.$store.commit(DEMO_DIALOG_IS_SHOW, value);
		},

		// 切换显示不同地区的GAMES
		showGameFromTypeBottom(index)
		{
			this.currentOpenMenuIndex = index;
			this.allGames             = [];
			if(index === 0)// ALL
			{
				this.allGames = this.allGamesSource.filter(game => game.visible === true);
			}
			else if(index > 0)// Others
			{
				this.allGames = this.allGamesSource.filter(game => Number(game.category) === Number(index));
				this.allGames.sort((a, b) => Number(b.game_id) - Number(a.game_id));
			}
		},

		// 加载 allGames（缓存优先，无则请求）
		async loadAllGames()
		{
			try {
				const data = await fetchAllGamesCached();
				this.allGamesSource = (data || []).map(g => ({ ...g, visible: true }));
				this.showGameFromTypeBottom(0);
			} catch (err) {
				console.error('=== Mobile__AllGamesView__load failed >>>', err);
			}
		},

		// 跳转到游戏详情页
		gotoGameDetail(currentGameId)
		{
			// console.log('=== gotoGameDetail__currentGameId >>>', currentGameId);
			// this.$store.commit(CURRENT_GAME_ID, currentGameId);

			let sign = this.$Common.makeSign(this, currentGameId);
			this.$router.push({
				path: `/gamedetail/${currentGameId}/${sign}`
			});
		},

		handleError(event)
        {
            /* console.log('event >>>', event);
            event.target.src = require('@/assets/static/imgs/common/google-cloud.png'); */
        },

		/**
		 * 计算 left 值
		 * 暂未启用
		 * :style="{ left: floatLeft(index) }"
		 */
		floatLeft(index)
		{
			return `${index * 240}px`;
		}
	},

	computed: {
		// 计算横线数量
		crossLines()
		{
			let showLines    = 1;// 默认当前显示的行数
			let oneLines     = 3;// 一行显示多少个ICON（一行阴影，显示的是12个ICON）
			if(this.allGames.length > 0)
			{
				let visibleGames = this.allGames.filter(game => game.visible === true);// 过滤出 visible 属性为 true 的游戏
				let games        = visibleGames.length;// 可见游戏的数量
				if(games > oneLines*2)
				{
					showLines = Math.floor(games / oneLines);// 例：n = 向下取整(19 / 6);
				}
			}
			return showLines;
		}
	},

	beforeDestroy() {
		window.removeEventListener("scroll", this.handleScroll);
	}
}
</script>

<style lang="less" scoped>
.home_wrapper{
	width:var(--com-base-container-wm);height:auto;
	padding-top:0;
}
.home_container{
	display:flex;justify-content:center;align-items:flex-start;
	width:100%;height:var(--com-base-top-container-h2);
}
.all_games_container{
	display:flex;justify-content:center;align-items:flex-start;
	width:100%;min-height:var(--com-base-top-container-h3);
	background:#E6F0FF;
	.all_games_gradient_1{
		margin:0 auto;
		width:var(--com-base-container-wm);min-height:var(--com-base-top-container-h3);
		display:flex;flex-direction:column;justify-content:flex-start;align-items:center;
		.menu_top{
			display:flex;justify-content:center;align-items:center;
			width:inherit;height:auto;
			margin-top:50px;
			.menu_scroll_container{
				display:flex;justify-content:flex-start;align-items:center;
				width:var(--com-base-content-wm);
				overflow-x:auto;
				overflow-y:hidden;
				white-space:nowrap;
				-ms-overflow-style:none;/* IE和Edge浏览器隐藏滚动条 */
  				scrollbar-width:none;   /* Firefox隐藏滚动条 */
				.menu_top_item_wrapper{
					display:inline-block;
					.menu_top_item{
						display:flex;flex-direction:row;justify-content:center;align-items:center;
						width:260px;height:70px;margin-right:30px;
						border:2px solid rgba(255, 255, 255, 0.5);border-radius:14px;
						background:#F5F9FF;
						cursor:pointer;
						div{
							height:50px;line-height:50px;
							font-size:var(--com-base-fz-24);font-weight:bold;text-align:center;
							color:var(--com-main-ft-color);
							img{
								width:48px;height:48px;
								margin-right:5px;
							}
						}
					}
				}
				.active{
					.menu_top_item{
						border:2px solid #1D55FF;
						background:#FEFEFF;
						div{
							color:#1D55FF !important;
						}
					}
					/* div{
						color:#1D55FF !important;
					}
					div:nth-child(2){
						background:#1D55FF;
					} */
				}
			}
			.menu_scroll_container::-webkit-scrollbar{
				display:none;/* Chrome、Safari和Edge隐藏滚动条 */
			}
		}
		.menu_bottom{
			position:relative;
			width:var(--com-base-container-wm);height:auto;/* height:720px;margin-bottom:240px; */
			display:flex;justify-content:flex-start;align-items:flex-start;flex-wrap:wrap;
			.menu_bottom_item{
				position:relative;
				border-radius:25px;
				width:250px;height:250px;
				/* display:flex;flex-direction:column;justify-content:flex-start;align-items:center; */
				display:flex;justify-content:center;align-items:center;
				img{
					width:130px;height:130px;
					border-radius:inherit;
					box-shadow:0 0 20px 0 #a1befc;
					cursor:pointer;
				}
				div{
					position:absolute;left:0;right:0;bottom:55px;margin:auto;
					padding:3px 10px;
					width:130px;height:40px;line-height:1.2;
					font-size:var(--com-base-fz-14);color:#FFF;font-weight:bold;text-align:center;
					display:flex;justify-content:center;align-items:center;
					white-space:pre-wrap;
					background:linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.1));
					border-radius:0 0 22px 22px;
				}
			}
			.menu_cross_line{
				pointer-events:none;
				position:absolute;top:0;left:0;right:0;margin:auto;
				width:var(--com-base-container-wm);height:500px;
				/* background:#F00 url(@/assets/static/imgs/common/m/icon_1v1.png) 0 0 no-repeat;
				background-size:500px 500px; */
			}
			.menu_cross_line_box_0 {top:0px;}
			.menu_cross_line_box_1 {top:250px;}
			.menu_cross_line_box_2 {top:500px;}
			.menu_cross_line_box_3 {top:750px;}
			.menu_cross_line_box_4 {top:1000px;}
			.menu_cross_line_box_5 {top:1250px;}
			.menu_cross_line_box_6 {top:1500px;}
			.menu_cross_line_box_7 {top:1750px;}
			.menu_cross_line_box_8 {top:2000px;}
			.menu_cross_line_box_9 {top:2250px;}
			.menu_cross_line_box_10{top:2500px;}
			.menu_cross_line_box_11{top:2750px;}
			.menu_cross_line_box_12{top:3000px;}
			.menu_cross_line_box_13{top:3250px;}
			.menu_cross_line_box_14{top:3500px;}
			.menu_cross_line_box_15{top:3750px;}
			.menu_cross_line_box_16{top:3750px;}
			.menu_cross_line_box_17{top:4000px;}
			.menu_cross_line_box_18{top:4250px;}
			.menu_cross_line_box_19{top:4500px;}
			.menu_cross_line_box_20{top:4750px;}
			.menu_cross_line_box_21{top:5000px;}
			.menu_cross_line_box_22{top:5250px;}
			.menu_cross_line_box_23{top:5500px;}
			.menu_cross_line_box_24{top:5750px;}
			.menu_cross_line_box_25{top:6000px;}
			/* IF MORE, THEN ADD MORE */
		}
	}
}
</style>
